<script setup>
import { router, Head, Link, useForm } from '@inertiajs/vue3';
import { computed } from 'vue';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import JetButton from '@/Jetstream/Button.vue';
import AppTheming from '@/Jetstream/AppTheming.vue';

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

const props = defineProps({
    status: String,
});

const form = useForm({});

const submit = () => {
    form.post(route(urlNamePrefix+'verification.send'));
};

const verificationLinkSent = computed(() => props.status === 'verification-link-sent');
</script>

<template>
    <AppTheming />
    <Head title="Email Verification" />

    <JetAuthenticationCard>
        <template #logo>
            <JetAuthenticationCardLogo />
        </template>

        <div class="mb-4 text-sm text-gray-600">
            {{ $t('application.email_verification.info') }}
        </div>

        <div v-if="verificationLinkSent" class="mb-4 font-medium text-sm text-green-600">
            {{ $t('application.email_verification.link_sent') }}
        </div>

        <form @submit.prevent="submit">
            <div class="mt-4 flex items-center justify-between">
                <JetButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    {{ $t('application.email_verification.resend_button') }}
                </JetButton>

                <div>
                    <Link
                        :href="route(urlNamePrefix+'logout')"
                        method="post"
                        as="button"
                        class="underline text-sm text-gray-600 hover:text-gray-900 ml-2"
                    >
                        {{ $t('application.navigation.log_out') }}
                    </Link>
                </div>
            </div>
        </form>
    </JetAuthenticationCard>
</template>
